

























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
//import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker-exact.vue";
//import { Quill } from "vue-quill-editor";
import { ImageDrop } from "quill-image-drop-module";
import * as quillBetterTable from "quill-better-table";

import AnnoucementService from "@/services/Annoument.service";
import PorposalService from "@/services/porposal.service";
import Annoucement from "../../models/annoucement/annoucement.Model";
import AnnoucementPublish from "../../models/annoucement/annoucementPublish.Model";
import SendedPorposal from "@/models/porposal/sendedPorposal.Model";
import GenericAdd from "../../core/Generics/GenericAdd";
import Porposal from "@/models/porposal/porposal.model";
import { PorposalModality } from "@/enums/PorposalModality";
import { PorposalExpectedResult } from "@/enums/PorposalExpectedResult";
import ProposalMember from "../../models/porposal/porposalMembers.model";
import MemberTypeService from "@/services/memberType.service";
import ProjectTypeService from "@/services/projectType.service";
import BudgetExpenseService from "@/services/budgetExpense.service";
import CoinService from "@/services/coins.service";
import DocumentComponent from "@/components/PublishAnnoucement/document.vue";
import ProposalDocument from "@/models/porposal/proposalDocument.Model";
import ProposedConsortium from "@/models/porposal/proposedConsortium.Model";
import moment from "moment";
import PorposalBudgetItem from "@/models/porposal/porposalBudgetItem.model";
import BudgetItem from "../../models/porposal/budgetItem.model";
import { Utils } from "../../core/Utils";
import { BudgetItemCalculation } from "../../enums/BudgetItemCalculation";
import { Watch } from "vue-property-decorator";
import PorposalBudgetSubItem from "@/models/porposal/porposalBudgetSubItem.model";
import BudgetSubItem from "@/models/porposal/budgetSubItem.model";
import { YearPeriod } from "../../enums/YearPeriod";
import Membertype from "../../models/porposal/memberType.Model";
import PorposalBudgetSubItemInstitutionDetail from "@/models/porposal/porposalBudgetSubItemInstitutionDetail.model";
import UserService from "@/services/user.service";
import BaseModel from "../../models/base/BaseModel.model";
import UserWithoutCode from "@/models/userWithoutCode.Model";
import BaseSelectPerson from "@/components/base/baseSelectPerson/baseSelectPerson.vue";
import BaseSelectMember from "@/components/base/baseSelectPerson/baseSelectMembers.vue";
import PorposalMemberService from "../../services/porposalMember.service";
import { bus } from "../../main";
import BaseSelectResearchCenter from "@/components/base/baseSelectResearchCenter/baseSelectResearchCenter.vue";
import MemberType from "@/models/porposal/memberType.Model";
import User from "../../models/security/user.model";
import fileService from "@/services/file.service";
import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue";
import UserBasicInformationCni from "@/components/user-basic-information/userBasicInformationCni.vue";
import GantCharttComponent from "@/components/ganttChart/gantChartt.vue";
import Proposal from "@/modules/proposal/proposal.vue";
import PorposalMemberEffort from "../../models/porposal/porposalMemberEffort.model";
import ProposalScheduleGanttPhase from "../../models/porposal/proposalScheduleGanttPhase.model";
import ProposalScheduleGanttActivity from "@/models/porposal/ProposalScheduleGanttActivity.model";
import PorposalProjectType from "../../models/porposal/porposalProjectType.model";
import ProjectType from "@/models/porposal/sendedPorposal.Model";
import FacultityService from "@/services/researchCenter.service";
import ExpectedResult from "../../models/porposal/expectedResult.model";
import ExperienceUser from "@/models/curriculum/experienceUser.Model";
import EspecificObjective from "@/models/porposal/especificObjective.model";
declare var google: any;
import * as Quill from 'quill'
import QuillEditorJs from '@/components/quill-editor/quill-editor.vue'
import QuillEditorTextJs from '@/components/quill-editor/quill-editor-text.vue'

@Component({
  components: {
    DatePickerComponent,
    documentcomponent: DocumentComponent,
    BaseSelectResearchCenter,
    BaseSelectPerson,
    UserBasicInformationComponent,
    GantCharttComponent,
    UserBasicInformationCni,
    BaseSelectMember,
    QuillEditorJs,
    QuillEditorTextJs
  },
})
export default class PorposalApply extends GenericAdd<Porposal> {
  userService: UserService = new UserService();
  facultyRepository: FacultityService = new FacultityService();
  editorOption = {
    modules: {
      toolbar: [
        ["bold", "italic", "underline"],
        ["blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ size: ["small", false, "large", "huge"] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ font: [] }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ["clean"],
        ["link", "image", "video"],
      ],
      //imageDrop: true,
      //table: true
    },
    placeholder: "Escriba el contenido aqui...",
  };
  dependencies: [] = [];
  researchCenters = [];
  faculties: any = [];
  userObj = {};
  showExpectResult = false;
  currentTab = 1;
  memberTypes: Array<Membertype> = [];
  projectTypes: any = [];
  isActive = false;
  projecTypesSelects = [];
  annoucementService = new AnnoucementService();

  annoucementId: number = 0;
  proposalMember = new ProposalMember();
  annoucement: AnnoucementPublish = new AnnoucementPublish();
  CoinService = new CoinService();
  PorposalModality = PorposalModality;
  proposalMemberEffort = new PorposalMemberEffort();
  PorposalExpectedResult = PorposalExpectedResult;
  proposedConsortiums = new ProposedConsortium();
  memberTypeService: MemberTypeService = new MemberTypeService();
  projectTypeService: ProjectTypeService = new ProjectTypeService();
  porposalMemberService: PorposalMemberService = new PorposalMemberService();
  userExedThelimiteds = [];
  contentTypeId = null;
  showModal = false;
  code = "0";
  modelUser = new UserWithoutCode();
  loading = false;
  showAddPartida = false;
  counter: number;
  principalInvestigatorName = "";
  principalInvestigator:Membertype = new Membertype();
  fullName = "";
  memberType = "";
  userId = null;
  objMemberType = {
    quantity: 0,
  };
  membersDetailedOpend = [];
  files = [];
  finalResultUsersExed = [];
  dropFiles = [];
  filesUploa = [];
  selected = {};
  memberTypeId = 0;
  userThatExcedTheCondition = [];
  defaultOpenedMemberDetails = [];
  words: any;
  valueHourChange = null;
  hourWork = null;
  counterAb: number;
  showUserWithoutCodes = false;
  Coins: [];
  years: Array<number> = [];
  budgetExpenses = [];
  budgetItemCurrent = new PorposalBudgetItem();
  budgetExpenseService = new BudgetExpenseService();
  BudgetItemCalculation = BudgetItemCalculation;
  showAddSubPartida = false;
  budgetSubItemCurrent = new PorposalBudgetSubItem();
  showModalSchedule = false;
  totalBudgetFondocyt: number = 0;
  totalBudget: number = 0;
  totalBudgetInstitutionalAport: number = 0;
  showWarning = false;
  institutionsForMemberEfforts = [];
  enableSeconds = false;
  showWeekNumber = false;
  hoursStrip: number = null;
  careerCode = null;
  isExeded = false;
  // ganttDiagramTable
  phaseActivities: Array<ProposalScheduleGanttActivity> = [];
  proposalScheduleGantt = new ProposalScheduleGanttPhase();
  proposalScheduleGanttActivity = new ProposalScheduleGanttActivity();
  defaultOpenedDetails: any = [];
  isEditingPhase: boolean = false;
  showDetailIcon: boolean = true;
  showModalSchedulePhase: boolean = false;
  additionalHoursForTheProject = 0;
  quill: any = null;

  getPrincipalInvestigator() {
    let name;
    this.memberTypeService.GetPrincipalInvestigator().then((response) => {
      this.principalInvestigator = response;
      this.principalInvestigatorName = response.name;
    });
  }

  removeExpectResult(arr: [], index: number) {
    arr.splice(index, 1);
  }
  public onTimetoStripLostFocus(value: any, row: ProposalMember) {
    row.hoursStrippedByActivity = 0;
    row.proposalMemberEfforts.forEach(
      (porposalMemberEffort: PorposalMemberEffort) => {
        row.hoursStrippedByActivity += Number(porposalMemberEffort.timeToStrip);
      }
    );
    if (row.additionalHoursForTheProject) {
      row.totalHoursThatYouWillSpend =
        Number(row.additionalHoursForTheProject) + row.hoursStrippedByActivity;
      row.percentageOfHourlyActivityPerWeek = Number(
        (
          (row.totalHoursThatYouWillSpend * 100) /
          row.hourWorkToWeekend
        ).toFixed(2)
      );
    }
  }
  onAditionalHourChange(row: any, arr: []) {
    if (row.additionalHoursForTheProject) {
      row.totalHoursThatYouWillSpend =
        Number(row.additionalHoursForTheProject) + row.hoursStrippedByActivity;
      row.percentageOfHourlyActivityPerWeek = Number(
        (
          (row.totalHoursThatYouWillSpend * 100) /
          row.hourWorkToWeekend
        ).toFixed(2)
      );
    } else {
      row.totalHoursThatYouWillSpend = "";
      row.percentageOfHourlyActivityPerWeek = "";
    }
  }

  addProjectTypes(projectType: ProjectType) {
    let item = new PorposalProjectType();
    if (
      this.model.porposalProjectTypes.some(
        (x: PorposalProjectType) => x.projectTypeId == projectType.id
      )
    ) {
      let Obj = this.model.porposalProjectTypes.find(
        (x: PorposalProjectType) => x.projectTypeId == projectType.id
      );
      let index = this.model.porposalProjectTypes.findIndex(
        (x: PorposalProjectType) => x.projectTypeId == projectType.id
      );
      this.model.porposalProjectTypes.splice(index, 1);
    } else {
      item.projectTypeId = projectType.id;
      item.name = projectType.name;
      this.model.porposalProjectTypes.push(item);
    }
  }
  onCloseModal(row: any) {
    row.showExpectResult = false;
    this.$nextTick().then(() => {
      this.$forceUpdate();
    });
  }

  showExpectResultOnClic(row: any, index: number) {
    row.showExpectResult = true;
    this.$nextTick().then(() => {
      this.$forceUpdate();
    });
  }

  onInputLostFocus(value: number) {
    let valueParseToNumber = Number(value);
    if (valueParseToNumber > this.annoucement.maximumHourWorked) {
      this.$buefy.toast.open({
        message: `Has Excedido el límite de horas trabajada a la semana,
                 el límite es ${
                   this.annoucement.maximumHourWorked
                 } te excediste con 
                 una diferencia de ${
                   valueParseToNumber - this.annoucement.maximumHourWorked
                 }`,
        queue: false,
        duration: 6000,
        type: "is-danger",
        position: "is-top-right",
      });
      this.isExeded = true;
    } else {
      this.isExeded = false;
    }
  }

  /*
  setActivityModal(phase: ProposalScheduleGanttPhase) {
    this.phaseActivities = phase.proposalScheduleGanttActivities;
    this.proposalScheduleGanttActivity.phaseId = phase.taskId;
    this.showModalSchedule = true;
  }
  */

  setActivityModal(phase: ProposalScheduleGanttPhase) {
    this.phaseActivities = phase.proposalScheduleGanttActivities.filter(
      (x) => !x.deleted
    );
    this.proposalScheduleGanttActivity.phaseStartDateUI = phase.startDate;
    this.proposalScheduleGanttActivity.phaseEndDateUI = phase.endDate;
    this.proposalScheduleGanttActivity.phaseId = phase.taskId;
    this.showModalSchedule = true;
  }

  setEditPhaseModal(phase: ProposalScheduleGanttPhase) {
    this.proposalScheduleGantt.taskId = phase.taskId;
    this.proposalScheduleGantt.order = phase.order;
    this.proposalScheduleGantt.taskName = phase.taskName;
    this.proposalScheduleGantt.startDate = phase.startDate;
    this.proposalScheduleGantt.endDate = phase.endDate;
    this.isEditingPhase = true;
    this.showModalSchedulePhase = true;
  }

  addExpectResult(row: any) {
    let isNotEmpty = false;
    row.expectedResults.forEach((element: ExpectedResult) => {
      if (!element.name) {
        isNotEmpty = true;
        this.$buefy.dialog.confirm({
          title: "Advertencia",
          message:
            "Debes llenar el campo que tienes vacio para agregar otro resultado esperado.",
          type: "is-danger",
          hasIcon: true,
          size: "is-medium",
        });
      } else {
        isNotEmpty = false;
      }
    });
    if (!isNotEmpty) row.expectedResults.push(new ExpectedResult());
  }

  onTimeToDedicateLostFocus(userId: number, value: number) {
    let storeTimeToDedicate = 0;
    this.model.porposalMembers.forEach((currentMember: ProposalMember) => {
      if (currentMember.userId == userId) {
        currentMember.proposalMemberEfforts.forEach(
          (currentMemberEffort: PorposalMemberEffort) => {
            storeTimeToDedicate += Number(currentMemberEffort.hour);
            if (storeTimeToDedicate > currentMember.hourWorkToWeekend) {
              let diference = 0;
              diference = storeTimeToDedicate - currentMember.hourWorkToWeekend;
              this.$buefy.toast.open({
                message: `Haz Excedido el limite de horas trabajada por actividad
                                con una diferencia de ${diference}`,
                queue: false,
                duration: 6000,
                type: "is-danger",
                position: "is-top-right",
              });
            }
          }
        );
      }
    });
  }

  @Watch("showModalSchedulePhase")
  onShowModalSchedulePhaseChange(value: boolean) {
    if (!value) this.cleanSchedulePhase();
  }

  @Watch("showModalSchedule")
  onShowModalScheduleActivityChange(value: boolean) {
    if (!value) this.cleanScheduleActivity();
  }
  @Watch("valueHourChange")
  onValueHourChange() {
    if (parseInt(this.valueHourChange, 10) > parseInt(this.hourWork, 10)) {
      this.$buefy.toast.open({
        message:
          "Las horas a dedicar a la actividad no puede ser mayor a las horas trabajada por la semana ",
        queue: false,
        duration: 5000,
        type: "is-danger",
        position: "is-top-right",
      });
    }
  }
  validarCodigo(row: PorposalMemberEffort, isActivity: Boolean) {
    if (isActivity) {
      row.timeToDedicateFinal = null;
      row.effortPorcentageFinal = null;
    }
  }
  removeTask(phaseId, taskId) {
    let phase = this.model.proposalScheduleGanttPhases.find(
      (x) => x.taskId == phaseId
    );
    if (
      phase.proposalScheduleGanttActivities.some((x) =>
        x.dependencies.includes(taskId)
      )
    )
      this.operationNoAllowed(
        "Hay otras actividades que dependen de la que desea eliminar."
      );
    else
      phase.proposalScheduleGanttActivities = phase.proposalScheduleGanttActivities.filter(
        (x) => x.taskId !== taskId
      );
  }

  removePhase(phaseId) {
    this.$buefy.dialog.confirm({
      title: "Advertencia",
      type: "is-warning",
      size: "is-medium",
      hasIcon: true,
      confirmText: "Sí",
      cancelText: "No",
      message: "¿Está seguro de querer eliminar esta Fase?",
      onConfirm: () =>
        (this.model.proposalScheduleGanttPhases = this.model.proposalScheduleGanttPhases.filter(
          (x) => x.taskId !== phaseId
        )),
    });
  }

  /*
  editPhase() {
    let editedPhase = this.model.proposalScheduleGanttPhases.find(
      x => x.taskId == this.proposalScheduleGantt.taskId
    );
    editedPhase.order = this.proposalScheduleGantt.order;
    editedPhase.taskName = this.proposalScheduleGantt.taskName;
    editedPhase.startDate = this.proposalScheduleGantt.startDate;
    editedPhase.endDate = this.proposalScheduleGantt.endDate;

    this.showModalSchedulePhase = false;
    this.isEditingPhase = false;
    this.cleanSchedulePhase();
  }
  */

  editPhase(obj: ProposalScheduleGanttPhase) {
    let editedPhase = this.model.proposalScheduleGanttPhases.find(
      (x) => x.taskId == this.proposalScheduleGantt.taskId
    );
    if (obj && obj.endDate > obj.startDate) {
      editedPhase.order = this.proposalScheduleGantt.order;
      editedPhase.taskName = this.proposalScheduleGantt.taskName;
      editedPhase.startDate = this.proposalScheduleGantt.startDate;
      editedPhase.endDate = this.proposalScheduleGantt.endDate;
      this.showModalSchedulePhase = false;
      this.isEditingPhase = false;
      this.cleanSchedulePhase();
    } else {
      this.operationNoAllowed(
        `La fecha final no puede ser menor o igual a la inicial`
      );
    }
  }
  /*
  addPhase(obj: ProposalScheduleGanttPhase) {
    this.model.proposalScheduleGanttPhases.push(
      this.getProposalScheduleGanttPhase()
    );
    this.showModalSchedulePhase = false;
    this.cleanSchedulePhase();
  }
  */

  addPhase(obj: ProposalScheduleGanttPhase) {
    if (obj && obj.endDate > obj.startDate) {
      this.model.proposalScheduleGanttPhases.push(
        this.getProposalScheduleGanttPhase()
      );
      this.showModalSchedulePhase = false;
      this.cleanSchedulePhase();
    } else {
      this.operationNoAllowed(
        `La fecha final no puede ser menor o igual a la inicial`
      );
    }
  }

  getProposalScheduleGanttPhase() {
    let proposalScheduleGantt = new ProposalScheduleGanttPhase();
    proposalScheduleGantt.taskId = Utils.newGUID();
    proposalScheduleGantt.order = this.proposalScheduleGantt.order;
    proposalScheduleGantt.taskName = this.proposalScheduleGantt.taskName;
    proposalScheduleGantt.resource = this.proposalScheduleGantt.resource;
    proposalScheduleGantt.startDate = this.proposalScheduleGantt.startDate;
    proposalScheduleGantt.endDate = this.proposalScheduleGantt.endDate;
    return proposalScheduleGantt;
  }

  cleanSchedulePhase() {
    this.isEditingPhase = false;
    this.proposalScheduleGantt.init();
    this.dependencies = [];
  }

  cleanScheduleActivity() {
    this.showModalSchedule = false;
    this.proposalScheduleGanttActivity.init();
    this.dependencies = [];
    this.phaseActivities = [];
  }

  /*
  addTask(obj: ProposalScheduleGanttActivity) {
    let phase = this.model.proposalScheduleGanttPhases.find(
      x => x.taskId == this.proposalScheduleGanttActivity.phaseId
    );
    phase.proposalScheduleGanttActivities.push(
      this.getProposalScheduleGanttActivity()
    );
    this.cleanScheduleActivity();
  }
  */

  addTask(obj: ProposalScheduleGanttActivity) {
    if (obj && obj.endDate > obj.startDate) {
      let dependenciasRequeridas = [];
      this.dependencies.forEach((dependency: ProposalScheduleGanttActivity) => {
        if (dependency.endDate >= obj.startDate)
          dependenciasRequeridas.push(dependency.taskName);
      });
      if (dependenciasRequeridas.length > 0) {
        dependenciasRequeridas.forEach((dependencia) => {
          this.operationNoAllowed(
            `La actividad: ${this.proposalScheduleGanttActivity.taskName} no puede iniciar antes de finalizar la actividad: ${dependencia}`
          );
        });
        return;
      }

      let phase = this.model.proposalScheduleGanttPhases.find(
        (x) => x.taskId == this.proposalScheduleGanttActivity.phaseId
      );
      phase.proposalScheduleGanttActivities.push(
        this.getProposalScheduleGanttActivity()
      );
      this.cleanScheduleActivity();
    } else {
      this.operationNoAllowed(
        "La fecha final no puede ser menor o igual a la inicial"
      );
    }
  }

  getProposalScheduleGanttActivity() {
    let proposalScheduleGantt = new ProposalScheduleGanttActivity();
    proposalScheduleGantt.taskId = Utils.newGUID();
    proposalScheduleGantt.order = this.proposalScheduleGanttActivity.order;
    proposalScheduleGantt.taskName = this.proposalScheduleGanttActivity.taskName;
    proposalScheduleGantt.resource = this.proposalScheduleGanttActivity.resource;
    proposalScheduleGantt.dependencies = this.dependencies
      .map((x: ProposalScheduleGanttActivity) => x.taskId)
      .join(",");
    proposalScheduleGantt.dependenciesUI = this.dependencies.map(
      (x: ProposalScheduleGanttActivity) => x.taskName
    );
    proposalScheduleGantt.startDate = this.proposalScheduleGanttActivity.startDate;
    proposalScheduleGantt.endDate = this.proposalScheduleGanttActivity.endDate;
    return proposalScheduleGantt;
  }

  // ganttDiagramTable

  onDropFilesChanges() {
    if (this.dropFiles) {
      this.dropFiles.forEach((currentDoc) => {
        this.files.push(currentDoc);
      });
      this.dropFiles = null;
    }
    this.showModal= false;
  }

  deleteDropFile(index: any) {
    this.dropFiles.splice(index, 1);
  }
  removeDocument(row: ProposalDocument) {
    if (row.id) {
      this.model.userDocuments.forEach((currentDocs: any) => {
        if (currentDocs.id === row.id) {
          currentDocs.deleted = true;
          let index = this.files.findIndex((x: any) => x.id == row.id);
          this.files.splice(index, 1);
        }
      });
    } else {
      this.files = this.files.filter((x: any) => x != row);
    }
  }

  getResearchCenter(value: BaseModel) {
    this.institutionsForMemberEfforts.push(value);
  }

  next() {
    this.currentTab++;
  }
  back() {
    this.currentTab--;
  }
  varlidate = "";
  addMemberEffort(row: any) {
    row.proposalMemberEfforts.push(new PorposalMemberEffort());
  }
  @Watch("model.startDate")
  onValidateDate() {
    if (this.model.startDate) {
      if (this.model.endDate) {
        let result = moment(this.model.startDate).isAfter(this.model.endDate);
        if (result) {
          return this.$buefy.toast.open({
            duration: 5000,
            message: "La fecha inicio debe ser menor a la fecha final",
            type: "is-danger",
          });
        }
      }
    }
  }

  @Watch("model.endDate")
  onValidateDatEnd() {
    if (this.model.startDate) {
      if (this.model.endDate) {
        let result = moment(this.model.startDate).isAfter(this.model.endDate);
        if (result) {
          return this.$buefy.toast.open({
            duration: 5000,
            message: "La fecha inicio debe ser menor a la fecha final",
            type: "is-danger",
          });
        }
      }
    }
  }
  @Watch("model.researchCenter")
  onResearchCenterChange() {
    this.proposalMemberEffort.institutionName = this.model.researchCenter.name;
  }

  @Watch("model.startDate")
  onValidateEmpty() {
    if (this.model.startDate) {
      if (this.model.endDate) {
        let result = moment(this.model.startDate).isAfter(this.model.endDate);
        if (result) {
          return (this.model.startDate = null);
        }
      }
    }
  }
  @Watch("model.endDate")
  onValidateEmptyEnd() {
    if (this.model.startDate) {
      if (this.model.endDate) {
        let result = moment(this.model.startDate).isAfter(this.model.endDate);
        if (result) {
          return (this.model.startDate = null);
        }
      }
    }
  }
  @Watch("model.periodMonth")
  onGrater48() {
    if (this.model.periodMonth)
      if (this.model.periodMonth > 48) {
        return this.$buefy.notification.open({
          duration: 10000,
          message:
            "Segun el articulo 30 del reglamento de Fondocyt la duracion máxima del proyecto es de 48 meses se le sugiere cambiarlo",
          type: "is-danger",
          hasIcon: true,
        });
      }
  }
  @Watch("userId")
  public getQuantityTime() {
    this.porposalMemberService
      .getQuantity(this.userId, this.annoucementId)
      .then((response: any) => {
        this.userExedThelimiteds = response;
      });
  }
  @Watch("objMemberType.quantity")
  getquantityTimeuser() {
    this.finalResultUsersExed = this.userExedThelimiteds.filter(
      (x) => x.memberTypeId == this.memberTypeId
    );
    if (
      this.finalResultUsersExed.length >= this.objMemberType.quantity &&
      this.objMemberType.quantity !== null
    ) {
      for (let i = 0; i < this.finalResultUsersExed.length; i++) {
        const currentObj = this.finalResultUsersExed[i];
        if (currentObj.memberTypeId != null) {
          if (
            !this.userThatExcedTheCondition.some(
              (x) => x.userId == currentObj.userId
            )
          ) {
            this.userThatExcedTheCondition.push(currentObj);
            break;
          }
        }
      }
    }
    this.objMemberType.quantity = undefined;
  }

  get getUserExedLimits() {
    return this.userThatExcedTheCondition
      .filter((x) => !x.deleted)
      .filter((x) => x.user)
      .map((x) => x.user);
  }

  getImage(image: any) {
    if (image) return `data:image/jpg;base64, ${image}`;
  }
  validateUserExed() {
    if (this.userThatExcedTheCondition.length > 0) {
      return (this.showUserWithoutCodes = true);
    }
  }
  protected async validate(ignoreWarnings: boolean = false) {
    try {
      if (this.annoucement.isRequiredCNI) {
        if (!this.showUserWithoutCodes) {
          this.validateUserExed();
          if (this.showUserWithoutCodes) {
            return;
          }
        }
      }

      var result = await this.$validator.validateAll();
      if (result) {
        // if (this.model.proposalScheduleGanttPhases.length > 0) {
        //   if (
        //     this.model.proposalScheduleGanttPhases.some(
        //       x => x.proposalScheduleGanttActivities.length == 0
        //     )
        //   ) {
        //     this.operationFailed(
        //       "Debe agregar actividades a todas las fases del diagrama de Gantt"
        //     );
        //     return;
        //   }
        // } else {
        //   this.operationFailed("Debe agregar fases al diagrama de Gantt");
        //   return;
        // }

        var memberTypesUnic = this.memberTypes.filter(
          (x: any) => x.isUniqueInPorposal
        );

        for (let i = 0; i < memberTypesUnic.length; i++) {
          const memberType = memberTypesUnic[i];
          var ammount = this.model.porposalMembers.filter(
            (x: any) => x.memberTypeId == memberType.id
          ).length;
          if (ammount > 1) {
            this.$buefy.toast.open({
              message: "No debe tener más de miembro tipo " + memberType.name,
              type: "is-danger",
              duration: 2000,
            });
            return;
          }
        }

        if (
          !ignoreWarnings &&
          (!this.validate20PercentInstitutionalAport ||
            this.validateBudgetItemIncludeInAnualRuleOfPayOfFondocyt ||
            this.validateBudgetSubItemDistribution ||
            this.validateBudgetItemRuleForPercentageLimitBasedInSubTotal)
        ) {
          this.showWarning = true;
        } else {
          this.showWarning = false;
          this.add();
        }
        return;
      }
      throw this.$validator.errors.items.map((e) => e.msg);
    } catch (errors) {
      this.operationFailedErrors(errors);
    }
  }
  cleanObject(sendObject: Porposal) {
    sendObject.porposalBudgetItems = sendObject.porposalBudgetItems.map((x) => {
      x.budgetItem = null;
      return x;
    });
    sendObject.porposalMembers = sendObject.porposalMembers.map((x) => {
      x.user = null;
      return x;
    });

    sendObject.coin = null;
    sendObject.researchCenter = null;
  }
  protected async add() {
    try {
      this.saving = true;
      this.model.proposedConsortiums.filter((x) => {
        x.originalName = x.name;
      });
      if (this.files.length && this.files.some((x) => x.size)) {
        let docs = await fileService.uploadMany(this.files as File[]);

        docs.forEach((doc) => {
          doc.refEntityKey = "Id";
          doc.refEntityName = "proposalDocument";

          let proposalDocument = new ProposalDocument();
          proposalDocument.document = doc;
          proposalDocument.contentTypeId = this.contentTypeId;
          if (proposalDocument) {
            this.model.proposalDocuments.push(proposalDocument);
          }
        });
      }
      this.changeConsortiums();
      var sendObject = Utils.mapToObject(
        this.model,
        new Porposal()
      ) as Porposal;
      this.cleanObject(sendObject);

      // presupuesto
      sendObject.totalBudgetHistory = this.totalBudget;
      sendObject.fondocytContribution = this.totalBudgetFondocyt;
      sendObject.totalCounterPart =
        this.totalBudgetInstitutionalAport +
        (this.totalBudget -
          this.totalBudgetFondocyt -
          this.totalBudgetInstitutionalAport);
      // end presupuesto

      let result = await this.repository.create(sendObject);
      
      this.saving = false;
      this.$emit("add", result);
      this.clean();
      this.operationSuccess();
      this.$router.push(`/nationalInterest-edit/` + result.id);
      if (this.exitOnSave) this.confirmedCancel();
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.saving = false;
    }
  }

  constructor() {
    super();
    this.controller = "Porposal";
    this.model = new Porposal();
    this.words = "";
    this.counter = 0;
    this.counterAb = 0;
    this.Coins = [];
  }

  onChangeDocs(tipos: any, docs: any[]) {
    this.model.proposalDocuments = docs.map((x) => {
      let doc = new ProposalDocument();
      doc.documentId = x.documentId;
      doc.document = x.document;
      return doc;
    });
  }

  memberTypeSelect(value: BaseModel) {
    this.objMemberType.quantity = value.quantity;
    this.memberTypeId = value.id;
  }
  userSelected(row: any) {
    this.careerCode = row.careerCode;
    this.userId = row.id;
    if (this.annoucement.isRequiredCNI) {
      if (!row.careerCode || row.careerCode == 0) {
        this.$buefy.dialog.confirm({
          title: "Advertencia",
          message:
            "El usuario" +
            ` <b>${row.fullName},` +
            " " +
            "no tiene el código de la carrera nacional de investigadores," +
            "mientras este usuario no tenga el código de la carrera nacional" +
            " de investigadores  esta propuesta no podrá ser enviada.",
          type: "is-warning",
          hasIcon: true,
          size: "is-medium",
        });
      }
    }
  }

  get user() {
    return this.$store.state.user;
  }

  updateDeltaView(quill) {
    document.body.querySelector("#delta-view").innerHTML = JSON.stringify(
      quill.getContents()
    );
  }
  getAnnoucementIdNationalId(){
    this.annoucementService.getAnnouncementIdNationalInterest().then(response =>{
        this.annoucementId = response;
    })
  }

  mounted() {
    this.getPrincipalInvestigator();
    this.getAnnoucementIdNationalId();
    var consotium = new ProposedConsortium();
    this.model.especificObjectives.push(new EspecificObjective());
    this.model.especificObjectives.forEach(
      (espesictObjective: EspecificObjective) => {
        espesictObjective.expectedResults.push(new ExpectedResult());
      }
    );
    
  }
  @Watch("principalInvestigator")
    onprincipalInvestigatorChange(){
      this.loading = true
    var member = new ProposalMember();

member.hasUser = true;
    member.userId = this.user.id;
    member.memberTypeId =  this.principalInvestigator.id;
    member.opendKey = Utils.newGUID();
    this.model.porposalMembers.push(member);
    this.defaultOpenedMemberDetails.push(member.opendKey);
    this.loading = false;
    }

  getContent() {
    console.log(this.quill.root.innerHTML);
  }

  created() {

    this.userId = this.user.id;
    this.getAnnoucementDetail();
    this.getMemberTypes();
    this.getProjectTypes();
    this.getCoins();
    this.getUser();
    this.getBudgetExpenses();
    this.getcenterByInvestigatorId();
  }
  addEspecificObjective() {
    let isNotEmpty = false;
    this.model.especificObjectives.forEach(
      (currentEspecificObjective: EspecificObjective) => {
        if (!currentEspecificObjective.especificObjetive) {
          isNotEmpty = true;
          this.$buefy.dialog.confirm({
            title: "Advertencia",
            message: "Debes completar el campo de objetivo específico",
            type: "is-danger",
            hasIcon: true,
            size: "is-medium",
          });
        }
        if (!currentEspecificObjective.expectedResults.length) {
          isNotEmpty = true;
          this.$buefy.dialog.confirm({
            title: "Advertencia",
            message: "Debes tener al menos un resultado esperado",
            type: "is-warning",
            hasIcon: true,
            size: "is-medium",
          });
        } else {
          isNotEmpty = false;
        }
      }
    );

    if (!isNotEmpty) {
      this.model.especificObjectives.push(new EspecificObjective());
    }
  }
  removeEspecificObjective(row: any) {
    this.model.especificObjectives = this.model.especificObjectives.filter(
      (x: any) => x != row
    );
  }
  @Watch("model.executiveSummary")
  public onWordCounterChange() {
    if (this.model.executiveSummary) {
      this.words = this.model.executiveSummary.split(" ");
      this.counter = this.words.length;
    }
  }
  @Watch("counter")
  public onCounterChange() {
    this.counter > 250 ? (this.counter = 250) : "0";
  }
  public wordCounter(event: any) {
    if (this.counter === 250) {
      event.preventDefault();
    }
    if (event.keyCode === 32) {
      if (this.model.executiveSummary) {
        this.words = this.model.executiveSummary.split(" ");
        this.counter = this.words.length;
      }
    } else if (event.keyCode === 8) {
      if (this.model.executiveSummary) {
        this.words = this.model.executiveSummary.split(" ");
        this.counter = this.words.length;
      }
      this.counter === 1 ? (this.counter = 0) : "";
    }
  }

  @Watch("annoucementId")
  getAnnoucementDetail() {
    this.model.annoucementId = this.annoucementId;
    this.loading = true;
    this.annoucementService
      .getDetailAnnocement(this.annoucementId)
      .then((response) => {
        this.model.startDate = new Date(response.dateEnd);
        this.annoucement = response;
        this.loading = false;
      });
  }

  addMember() {
  
  let item = new ProposalMember();
    item.opendKey = Utils.newGUID();
    this.model.porposalMembers.push(item);
    this.defaultOpenedMemberDetails.push(item.opendKey);


  }

  removeMember(row: any) {
    this.model.porposalMembers = this.model.porposalMembers.filter(
      (x: any) => x != row
    );
  }
  removeMemberEffort(array: [], index: number) {
    array.splice(index, 1);
  }

  public removeConsortium(row: any) {
    this.model.proposedConsortiums = this.model.proposedConsortiums.filter(
      (x: any) => x != row
    );
  }

  getMemberTypes() {
    this.memberTypeService.getAll().then((list: any) => {
      this.memberTypes = list;
    });
  }

  public addConsortium() {
    this.model.proposedConsortiums.push(new ProposedConsortium());
  }
  getProjectTypes() {
    this.projectTypeService.getAll().then((list: any) => {
      this.projectTypes = list;
    });
  }

  get totalInMounth() {
    let startDate = this.model.startDate as any;
    let endDate = this.model.endDate as any;
    this.model.periodMonth = Math.abs(moment(startDate).diff(endDate, "M"));
    this.model.periodMonth = Math.ceil(
      moment(endDate).diff(startDate, "month", true)
    );
    this.years = [];

    if (startDate & endDate) {
      var years = endDate.getFullYear() - startDate.getFullYear() + 1;
      for (let i = 1; i <= years; i++) {
        this.years.push(i);
      }
    }

    return this.model.periodMonth;
  }

  getCoins() {
    this.CoinService.getCoins().then((response) => {
      if (response) {
        this.Coins = response;
        this.model.coinId = response[0].id;
      }
    });
  }
  public getcenterByInvestigatorId() {
    if (this.userService) {
      this.userService
        .researchCenterByInvestigator(this.user.id)
        .then((center) => {
          this.researchCenters = center;
        });
    }
  }

  getBudgetExpenses() {
    this.budgetExpenseService.getBudgetExpenses().then((response) => {
      if (response) {
        this.budgetExpenses = response;
      }
    });
  }

  showBudgetItem(budgetExpenseId: number) {
    this.showAddPartida = true;
    this.budgetItemCurrent.budgetExpenseId = budgetExpenseId;
  }
  addPartida() {
    if (this.budgetItemCurrent.budgetItem.id) {
      var newPartida = Utils.mapToObject(
        this.budgetItemCurrent,
        new PorposalBudgetItem()
      ) as PorposalBudgetItem;

      this.model.porposalBudgetItems.push(newPartida);
      this.budgetItemCurrent.init();
      this.showAddPartida = false;
    } else {
      this.operationFailed("Debe seleccionar una partida");
    }
  }
  deletePartida(item: PorposalBudgetItem) {
    this.model.porposalBudgetItems = this.model.porposalBudgetItems.filter(
      (budgetItem) => budgetItem != item
    );
  }

  onBugetItem(item: BudgetItem) {
    this.budgetItemCurrent.budgetItem = item;
  }
  onRemoveBugetItem() {
    this.budgetItemCurrent.budgetItem = new BudgetItem();
  }

  calculateProposalBudgetSubItemByInstitution(
    porposalBudgetSubItem: PorposalBudgetSubItem
  ) {
    if (porposalBudgetSubItem.currentInstitution == 0) {
      var filteredDetails = porposalBudgetSubItem.porposalBudgetSubItemInstitutionDetails.filter(
        (x) => x.isFondocyt
      );
      return filteredDetails.reduce((a: any, b: any) => {
        var amount = b.amount ? parseFloat(b.amount as any) : 0;
        return a + amount;
      }, 0);
    } else {
      var filteredDetails = porposalBudgetSubItem.porposalBudgetSubItemInstitutionDetails.filter(
        (x) =>
          x.researchCenterId == porposalBudgetSubItem.currentInstitution ||
          x.institutionName == porposalBudgetSubItem.currentInstitution
      );
      return filteredDetails.reduce((a: any, b: any) => {
        var amount = b.amount ? parseFloat(b.amount as any) : 0;
        return a + amount;
      }, 0);
    }
  }

  calculateProposalBudgetSubItem(porposalBudgetSubItem: PorposalBudgetSubItem) {
    return porposalBudgetSubItem.porposalBudgetSubItemInstitutionDetails.reduce(
      (a: any, b: any) => {
        var amount = b.amount ? parseFloat(b.amount as any) : 0;
        return a + amount;
      },
      0
    );
  }
  calculateProposalBudgetItemByYear(porposalBudgetItem: PorposalBudgetItem) {
    var budgets = porposalBudgetItem.porposalBudgetItemInstitutions.filter(
      (x: any) => x.yearNumber == porposalBudgetItem.currentYear
    );
    return budgets.reduce((a: any, b: any) => {
      var amount = b.amount ? parseFloat(b.amount as any) : 0;
      return a + amount;
    }, 0);
  }

  get canConfigureBudget() {
    return (
      this.model.startDate &&
      this.model.endDate &&
      this.model.coinId &&
      this.model.researchCenterId
    );
  }

  showModalBudgetSubItem(porposalBudgetItem: PorposalBudgetItem) {
    this.showAddSubPartida = true;
    this.budgetSubItemCurrent.porposalBudgetItem = porposalBudgetItem;
    this.budgetSubItemCurrent.budgetItemId = porposalBudgetItem.budgetItemId;
  }
  addBudgetSubItem() {
    if (this.budgetSubItemCurrent.budgetSubItem) {
      var porposalBudgetSubItem = Utils.mapToObject(
        this.budgetSubItemCurrent,
        new PorposalBudgetSubItem()
      ) as PorposalBudgetSubItem;

      var defaultPeriod = YearPeriod.ThreeMonth;
      var quantityMonth = 12;
      var quantityPeriodInYear = quantityMonth / defaultPeriod;

      for (let y = 0; y < this.years.length; y++) {
        const year = this.years[y];

        var startPeriod = 1;
        var endPeriod = quantityPeriodInYear;
        if (y == 0) {
          if (this.model.startDate) {
            var startPeriod = Math.ceil(
              (this.model.startDate.getMonth() + 1) / defaultPeriod
            );
          }
        } else if (y == this.years.length - 1) {
          if (this.model.endDate) {
            endPeriod = Math.ceil(
              (this.model.endDate.getMonth() + 1) / defaultPeriod
            );
          }
        }

        for (let i = startPeriod; i <= endPeriod; i++) {
          let detail = new PorposalBudgetSubItemInstitutionDetail();
          detail.yearNumber = year;
          detail.periodNumber = i;
          detail.isFondocyt = true;
          porposalBudgetSubItem.porposalBudgetSubItemInstitutionDetails.push(
            detail
          );
        }
        let detail2 = new PorposalBudgetSubItemInstitutionDetail();
        detail2.yearNumber = year;
        detail2.researchCenterId = this.model.researchCenterId;
        porposalBudgetSubItem.porposalBudgetSubItemInstitutionDetails.push(
          detail2
        );

        this.model.proposedConsortiums.filter(
          (consortium: ProposedConsortium) => {
            let detail = new PorposalBudgetSubItemInstitutionDetail();
            detail.yearNumber = year;
            detail.institutionName = consortium.name;
            detail.researchCenterId = null;
            porposalBudgetSubItem.porposalBudgetSubItemInstitutionDetails.push(
              detail
            );
          }
        );
      }

      this.budgetSubItemCurrent.porposalBudgetItem.porposalBudgetSubItems.push(
        porposalBudgetSubItem
      );

      this.budgetSubItemCurrent.init();
      this.showAddSubPartida = false;
    } else {
      this.operationFailed("Debe escribir la sub-partida");
    }
  }

  onCancelSubPartida() {
    this.showAddSubPartida = false;
  }

  removePorposalBudgetSubItem(
    porposalBudgetSubItem: PorposalBudgetSubItem,
    porposalBudgetItem: PorposalBudgetItem
  ) {
    porposalBudgetItem.porposalBudgetSubItems = porposalBudgetItem.porposalBudgetSubItems.filter(
      (x: any) => x != porposalBudgetSubItem
    );
  }
  get validate20PercentInstitutionalAport() {
    if (!this.model.porposalBudgetItems.length) {
      return true;
    }
    return this.totalBudgetInstitutionalAport >= (this.totalBudget * 20) / 100;
  }

  get validateBudgetSubItemDistribution() {
    if (!this.model.porposalBudgetItems.length) {
      return "";
    }

    for (let i = 0; i < this.model.porposalBudgetItems.length; i++) {
      const item = this.model.porposalBudgetItems[i];
      for (let y = 0; y < item.porposalBudgetSubItems.length; y++) {
        const subitem = item.porposalBudgetSubItems[y];
        var amountDistribute = this.calculateProposalBudgetSubItem(
          subitem
        ).toFixed(2);
        var totalAmount = Number((subitem.unitCost * subitem.month).toFixed(2));

        var withoutDistribution = totalAmount - amountDistribute;

        if (withoutDistribution > 0) {
          return `En la sub-partida presupuestaria <b>${
            subitem.budgetSubItem
          }</b> la  cual forma parte de la partida <b>${
            item.budgetItem.name
          }</b>  faltan por distribuir entre instituciones el monto de  <b>
           ${this.$options.filters.currency(withoutDistribution)}</b>.`;
        } else if (withoutDistribution < 0) {
          return `En la sub-partida presupuestaria <b>${
            subitem.budgetSubItem
          }</b> la  cual forma parte de la partida <b>${
            item.budgetItem.name
          }</b>  se ha distribuido entre instituciones un monto de extra de  <b>
          ${this.$options.filters.currency(withoutDistribution * -1)}</b>.`;
        }
      }
    }
  }
  get validateBudgetItemIncludeInAnualRuleOfPayOfFondocyt() {
    if (!this.model.porposalBudgetItems.length) {
      return "";
    }
    for (let z = 0; z < this.years.length; z++) {
      const year = this.years[z];
      var amountYearTopFondocyt = 0;
      var amountYear = 0;
      var porposalBudgetItems = this.model.porposalBudgetItems;

      for (let i = 0; i < porposalBudgetItems.length; i++) {
        const budgetItem = porposalBudgetItems[i];

        for (let j = 0; j < budgetItem.porposalBudgetSubItems.length; j++) {
          const subItem = budgetItem.porposalBudgetSubItems[j];
          var subBudgetInstitutions = subItem.porposalBudgetSubItemInstitutionDetails.filter(
            (x: PorposalBudgetSubItemInstitutionDetail) => x.yearNumber == year
          );

          for (let y = 0; y < subBudgetInstitutions.length; y++) {
            const subBudgetInstitution = subBudgetInstitutions[y];
            var amount = Number(subBudgetInstitution.amount.toFixed(2)) as any;
            if (subBudgetInstitution.isFondocyt) {
              amountYear += amount;

              if (
                budgetItem.budgetItem &&
                budgetItem.budgetItem.hasIncludeInAnualRuleOfPayOfFondocyt
              ) {
                amountYearTopFondocyt += amount;
              }
            }
          }
        }
      }
      var porcentaje = ((amountYearTopFondocyt * 100) / amountYear).toFixed(2);
      var pToN = Number(porcentaje);

      if (!Number.isNaN(pToN) && Number(pToN) > 10) {
        return `En el año <b>${year}</b> la suma de las partidas marcadas como <b>\"Incluidas para reglas\" </b> es mayor al 10% del tope anual de FONDOCYT. Actualmente FONDOCYT en su prespuesto esta cubriendo un  <b>${porcentaje}% </b> del año  <b>${year} </b>.`;
      }
    }
    return "";
  }

  get validateBudgetItemRuleForPercentageLimitBasedInSubTotal() {
    if (!this.model.porposalBudgetItems.length) {
      return "";
    }

    var subTotal = 0;
    var porposalBudgetItems = this.model.porposalBudgetItems.filter((x) =>
      x.budgetItem
        ? !x.budgetItem.hasRuleForPercentageLimitBasedInSubTotal
        : false
    );

    for (let i = 0; i < porposalBudgetItems.length; i++) {
      const budgetItem = porposalBudgetItems[i];

      for (let j = 0; j < budgetItem.porposalBudgetSubItems.length; j++) {
        const subItem = budgetItem.porposalBudgetSubItems[j];
        var subBudgetInstitutions =
          subItem.porposalBudgetSubItemInstitutionDetails;
        for (let y = 0; y < subBudgetInstitutions.length; y++) {
          const subBudgetInstitution = subBudgetInstitutions[y];
          var amount = Number(subBudgetInstitution.amount.toFixed(2)) as any;
          subTotal += amount;
        }
      }
    }

    var porposalBudgetItemsRuleForPercentage = this.model.porposalBudgetItems.filter(
      (x) =>
        x.budgetItem
          ? x.budgetItem.hasRuleForPercentageLimitBasedInSubTotal
          : false
    );

    for (let i = 0; i < porposalBudgetItemsRuleForPercentage.length; i++) {
      var total = 0;

      const budgetItem = porposalBudgetItemsRuleForPercentage[i];

      for (let j = 0; j < budgetItem.porposalBudgetSubItems.length; j++) {
        const subItem = budgetItem.porposalBudgetSubItems[j];
        var subBudgetInstitutions =
          subItem.porposalBudgetSubItemInstitutionDetails;
        for (let y = 0; y < subBudgetInstitutions.length; y++) {
          const subBudgetInstitution = subBudgetInstitutions[y];
          var amount = Number(subBudgetInstitution.amount.toFixed(2)) as any;
          total += amount;
        }
      }
      if (
        total >
        (subTotal * budgetItem.budgetItem.percentageLimitBasedInSubTotal) / 100
      ) {
        var porcentaje = ((total * 100) / subTotal).toFixed(2);

        return `La partida presupuestaria ${budgetItem.budgetItem.name} sobrepasa su limite de ${budgetItem.budgetItem.percentageLimitBasedInSubTotal}% basado en el subtotal actualmente tiene un porcentaje de ${porcentaje}.`;
      }
    }

    return "";
  }

  get institutionBudgetByYear() {
    var institutionBudgetByYear = [];

    this.totalBudgetFondocyt = 0;
    this.totalBudgetInstitutionalAport = 0;
    this.totalBudget = 0;

    if (!this.model.porposalBudgetItems.length) {
      return true;
    }

    for (let z = 0; z < this.years.length; z++) {
      const year = this.years[z];
      var resume = {
        year: 0,
        FONDOCYT: 0,
        institutionalAport: 0,
        othersInstitutions: 0,
      };
      for (let i = 0; i < this.model.porposalBudgetItems.length; i++) {
        const budgetItem = this.model.porposalBudgetItems[i];

        for (let j = 0; j < budgetItem.porposalBudgetSubItems.length; j++) {
          const subItem = budgetItem.porposalBudgetSubItems[j];
          var subBudgetInstitutions = subItem.porposalBudgetSubItemInstitutionDetails.filter(
            (x: PorposalBudgetSubItemInstitutionDetail) => x.yearNumber == year
          );
          resume.year = year;

          for (let y = 0; y < subBudgetInstitutions.length; y++) {
            const subBudgetInstitution = subBudgetInstitutions[y];
            var amount = Number(subBudgetInstitution.amount.toFixed(2)) as any;
            if (subBudgetInstitution.isFondocyt) {
              resume.FONDOCYT += amount;
            } else if (subBudgetInstitution.researchCenterId) {
              resume.institutionalAport += amount;
            } else {
              resume.othersInstitutions += amount;
            }
          }
        }
      }
      institutionBudgetByYear.push(resume);
      this.totalBudgetFondocyt += Number(resume.FONDOCYT.toFixed(2));
      this.totalBudgetInstitutionalAport += Number(
        resume.institutionalAport.toFixed(2)
      );
      this.totalBudget += Number(
        (
          Number(resume.FONDOCYT.toFixed(2)) +
          Number(resume.institutionalAport.toFixed(2)) +
          Number(resume.othersInstitutions.toFixed(2))
        ).toFixed(2)
      );
    }
    return institutionBudgetByYear;
  }
  @Watch("currentTab")
  onCurrentTab() {
    if (this.currentTab == 1) {
      this.model.proposedConsortiums.filter((x) => {
        x.originalName = x.name;
      });
    }
  }
  getUser() {
    this.loading = true;
    this.userService
      .getUserById(this.user.id)
      .then((user) => {
        this.userObj = user;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  onClickTabBudget() {
    this.currentTab = 7;
    if (this.model.modality == PorposalModality.PROPUESTACONSORCIONADA) {
      this.changeConsortiums();
    }
  }

  changeConsortiums() {
    this.model.proposedConsortiums.filter((consortium: ProposedConsortium) => {
      this.model.porposalBudgetItems.filter((item: PorposalBudgetItem) => {
        item.porposalBudgetSubItems.filter((subItem: PorposalBudgetSubItem) => {
          subItem.currentInstitution = 0;
          var any = subItem.porposalBudgetSubItemInstitutionDetails
            .filter((x) => {
              if (
                x.institutionName &&
                x.institutionName == consortium.originalName
              )
                x.institutionName = consortium.name;

              return !x.isFondocyt && !x.researchCenterId;
            })
            .some((detail: PorposalBudgetSubItemInstitutionDetail) => {
              return detail.institutionName == consortium.name;
            });

          if (!any) {
            for (let y = 0; y < this.years.length; y++) {
              const year = this.years[y];
              let detail = new PorposalBudgetSubItemInstitutionDetail();
              detail.yearNumber = year;
              detail.institutionName = consortium.name;
              detail.researchCenterId = null;
              subItem.porposalBudgetSubItemInstitutionDetails.push(detail);
            }
          }
        });
      });
    });

    this.model.porposalBudgetItems.filter((item: PorposalBudgetItem) => {
      item.porposalBudgetSubItems.filter((subItem: PorposalBudgetSubItem) => {
        subItem.porposalBudgetSubItemInstitutionDetails = subItem.porposalBudgetSubItemInstitutionDetails.filter(
          (x) =>
            x.isFondocyt ||
            x.researchCenterId ||
            this.model.proposedConsortiums.some(
              (y) => y.name == x.institutionName
            )
        );
      });
    });
  }
}
